var _style, _g, _g2, _path, _g3, _g4, _g5, _g6, _g7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCargoShipFast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 147.1 46.7",
    style: {
      enableBackground: "new 0 0 147.1 46.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{display:none;}\r\n\t.st2{display:inline;}\r\n\t.st3{fill:#FFFFFF;}\r\n\t.st4{fill:#231F20;}\r\n\t.st5{fill:url(#SVGID_1_);}\r\n\t.st6{fill:url(#SVGID_00000124851134307947733910000006893813616267230618_);}\r\n\t.st7{fill:url(#SVGID_00000035488553027458138060000011436899507328602773_);}\r\n\t.st8{fill:url(#SVGID_00000076588029746477535980000004670785613777044613_);}\r\n\t.st9{fill:url(#SVGID_00000054263117059454451430000008675246712310423990_);}\r\n\t.st10{fill:url(#SVGID_00000012471841893629590980000008171614422429920397_);}\r\n\t.st11{fill:url(#SVGID_00000049186230714910288050000009517779448210293164_);}\r\n\t.st12{fill:url(#SVGID_00000079451717562136123190000010798892194946262205_);}\r\n\t.st13{fill:url(#SVGID_00000125601752881396234810000008262266217022707383_);}\r\n\t.st14{fill:url(#SVGID_00000118361806236759609770000015812845466960724112_);}\r\n\t.st15{fill:url(#SVGID_00000005947172812881441540000009236833970378758589_);}\r\n\t.st16{fill:url(#SVGID_00000008860047722385803510000009508981842449756547_);}\r\n\t.st17{fill:url(#SVGID_00000080176453136763553210000018312260898135763373_);}\r\n\t.st18{fill:url(#SVGID_00000106857111107224735690000011438697632418096010_);}\r\n\t.st19{fill:url(#SVGID_00000035527402085731550730000015418138486613443985_);}\r\n\t.st20{fill:url(#SVGID_00000078727720102376771940000002688928581131028157_);}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 147.1,
    height: 46.7
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "sailboat_x5F_slow",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "V2",
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pleasure_Boat"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M44.8,19.8V28l-0.6,0.1c-5.3,1.1-12.9,1.7-20.7,1.7C8,29.8,1.9,24.7,1.7,24.5L1,23.9l0.7-0.6 C1.9,23.1,8,18,23.5,18c7.8,0,15.4,0.6,20.7,1.7L44.8,19.8L44.8,19.8L44.8,19.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M23.5,18.8c-15.4,0-21.3,5.1-21.3,5.1S8.1,29,23.5,29c8.1,0,15.4-0.6,20.5-1.6v-6.9 C38.9,19.4,31.6,18.8,23.5,18.8L23.5,18.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M35.7,20.1c-3.8-0.3-8-0.5-12.2-0.5c-11.8,0-17.9,3.1-20,4.4c2.1,1.3,8.2,4.4,20,4.4c4.3,0,8.5-0.2,12.2-0.5 c-0.4-1.1-0.6-2.4-0.6-3.8S35.4,21.2,35.7,20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M37.4,20.3c-0.5-0.1-1.1-0.1-1.7-0.2c-0.4,1.1-0.6,2.4-0.6,3.8s0.2,2.7,0.6,3.8c0.6,0,1.1-0.1,1.7-0.2 c-0.3-1.1-0.5-2.3-0.5-3.7S37.1,21.4,37.4,20.3L37.4,20.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M43.3,26.8v-5.7c-0.3-0.1-0.6-0.1-1-0.2c-1.5-0.2-3.1-0.5-4.9-0.7c-0.3,1.1-0.5,2.3-0.5,3.7s0.2,2.6,0.5,3.7 c1.8-0.2,3.4-0.4,4.9-0.7C42.6,26.9,43,26.8,43.3,26.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M42.5,21.7v4.4c-0.1,0-0.2,0-0.3,0.1c-1.3,0.2-2.7,0.4-4.2,0.6c-0.2-0.9-0.3-1.9-0.3-2.8s0.1-2,0.3-2.8 c1.5,0.2,2.9,0.4,4.2,0.6C42.3,21.7,42.4,21.7,42.5,21.7L42.5,21.7L42.5,21.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M35.3,23.9c0,0-3.2-3.7-7.2-3.7s-4.5,6.9-13.1,6.9c-5.8,0-11.6-3.2-11.6-3.2H35.3L35.3,23.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M23,22.9c0.6,0,1,0.5,1,1c0,0.6-0.5,1-1,1s-1-0.4-1-1C22,23.4,22.4,22.9,23,22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M38.7,23.6c0.2,0,0.3,0.1,0.3,0.3l0,0c0,0.2-0.1,0.3-0.3,0.3h-2.3c-0.2,0-0.3-0.1-0.3-0.3l0,0 c0-0.2,0.1-0.3,0.3-0.3H38.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M38.7,21.9c0-0.2,0.1-0.3,0.3-0.3l0,0c0.2,0,0.3,0.1,0.3,0.3v4c0,0.2-0.1,0.3-0.3,0.3l0,0 c-0.2,0-0.3-0.1-0.3-0.3V21.9z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "sailboat_x5F_medium",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "V2_00000059298110501461340310000018335675593991796916_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Medium_00000029037442317813450830000013629833412684213688_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 38.785,
    y1: 16.6337,
    x2: 77.125,
    y2: 16.6337,
    gradientTransform: "matrix(1 0 0 -1 0 49.9)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.74
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.51
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.33
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.19
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.08
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.02
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M77.1,33.5c-1.6-0.2-5.1,1.8-6.7,1.6s-4.5-3-6.1-3.2s-5.1,1.8-6.7,1.6s-4.5-3-6.1-3.2S46.6,32,45,31.8 s-6.2-2.3-6.2-2.3s4.4,3.9,6,4.1c1.6,0.2,5.1-1.8,6.7-1.6s4.5,3,6.1,3.2s5.1-1.8,6.7-1.6s4.5,3.5,6.1,3.2 C72.1,36.6,77.1,33.5,77.1,33.5L77.1,33.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031166445374849248090000013358778431279415711_",
    gradientUnits: "userSpaceOnUse",
    x1: 38.785,
    y1: 35.3246,
    x2: 77.125,
    y2: 35.3246,
    gradientTransform: "matrix(1 0 0 -1 0 49.9)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.74
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.51
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.33
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.19
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.08
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.02
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031166445374849248090000013358778431279415711_)"
    },
    d: "M77.1,14.3c-1.6,0.2-5.1-1.8-6.7-1.6 s-4.5,3-6.1,3.2c-1.6,0.2-5.1-1.8-6.7-1.6s-4.5,3-6.1,3.2C50,17.8,46.6,15.8,45,16c-1.6,0.2-6.2,2.3-6.2,2.3s4.4-3.9,6-4.1 s5.1,1.8,6.7,1.6s4.5-3,6.1-3.2s5.1,1.8,6.7,1.6c1.6-0.2,4.5-3.4,6.1-3.2C72.1,11.2,77.1,14.3,77.1,14.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013151409774757847160000009161591235681187231_",
    gradientUnits: "userSpaceOnUse",
    x1: 40.6266,
    y1: 17.8287,
    x2: 59.3219,
    y2: 17.8287,
    gradientTransform: "matrix(0.9991 -4.344502e-02 -4.344502e-02 -0.9991 6.8108 46.6773)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.74
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.51
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.33
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.19
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.08
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.02
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000013151409774757847160000009161591235681187231_)"
    },
    d: "M65.4,28c-1.2-0.1-4.5-0.8-6.1-0.9 s-5,2-6.6,1.8S46.5,25,46.5,25s4.7,1.9,6.3,2s5-2.3,6.6-1.8S65.4,28,65.4,28L65.4,28z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150095856427964869630000007325421727952963489_",
    gradientUnits: "userSpaceOnUse",
    x1: 52.0998,
    y1: 281.6661,
    x2: 70.7952,
    y2: 281.6661,
    gradientTransform: "matrix(0.9991 4.344502e-02 -4.344502e-02 0.9991 6.8108 -262.9173)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.74
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.51
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.33
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.19
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.08
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.02
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000150095856427964869630000007325421727952963489_)"
    },
    d: "M65.4,19.9c-1.2,0.1-4.5,0.8-6.1,0.9 c-1.6,0.1-5-2-6.6-1.8s-6.1,3.8-6.1,3.8s4.7-1.9,6.3-2s5,2.3,6.6,1.8S65.4,19.9,65.4,19.9L65.4,19.9z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Pleasure_Boat_00000127013911645405312890000006856156695579323313_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M44.7,19.9v8.2l-0.6,0.1c-5.3,1.1-12.9,1.7-20.7,1.7C8,29.9,1.9,24.8,1.6,24.6L1,24l0.7-0.6 c0.2-0.2,6.3-5.3,21.8-5.3c7.8,0,15.4,0.6,20.7,1.7L44.7,19.9L44.7,19.9L44.7,19.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M23.5,18.9C8.1,18.9,2.1,24,2.1,24s5.9,5.1,21.3,5.1c8.1,0,15.4-0.6,20.5-1.6v-6.9 C38.9,19.5,31.6,18.9,23.5,18.9L23.5,18.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M35.7,20.2c-3.8-0.3-8-0.5-12.2-0.5c-11.8,0-17.9,3.1-20,4.4c2.1,1.3,8.2,4.4,20,4.4c4.3,0,8.5-0.2,12.2-0.5 c-0.4-1.1-0.6-2.4-0.6-3.8S35.3,21.3,35.7,20.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M37.4,20.3c-0.5-0.1-1.1-0.1-1.7-0.2c-0.4,1.1-0.6,2.4-0.6,3.8s0.2,2.7,0.6,3.8c0.6,0,1.1-0.1,1.7-0.2 c-0.3-1.1-0.5-2.3-0.5-3.7S37,21.4,37.4,20.3L37.4,20.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M43.2,26.8v-5.7c-0.3-0.1-0.6-0.1-1-0.2c-1.5-0.2-3.1-0.5-4.9-0.7c-0.3,1.1-0.5,2.3-0.5,3.7s0.2,2.6,0.5,3.7 c1.8-0.2,3.4-0.4,4.9-0.7C42.6,26.9,42.9,26.9,43.2,26.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M42.5,21.8v4.4c-0.1,0-0.2,0-0.3,0.1c-1.3,0.2-2.7,0.4-4.2,0.6c-0.2-0.9-0.3-1.9-0.3-2.8c0-1,0.1-2,0.3-2.8 c1.5,0.2,2.9,0.4,4.2,0.6C42.2,21.7,42.4,21.8,42.5,21.8L42.5,21.8L42.5,21.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M35.3,24c0,0-3.2-3.7-7.2-3.7s-4.5,6.9-13.1,6.9C9.2,27.2,3.5,24,3.5,24H35.3L35.3,24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M23,23c0.6,0,1,0.5,1,1c0,0.6-0.5,1-1,1s-1-0.4-1-1C21.9,23.4,22.4,23,23,23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M38.7,23.7c0.2,0,0.3,0.1,0.3,0.3l0,0c0,0.2-0.1,0.3-0.3,0.3h-2.3c-0.2,0-0.3-0.1-0.3-0.3l0,0 c0-0.2,0.1-0.3,0.3-0.3H38.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M38.7,22c0-0.2,0.1-0.3,0.3-0.3l0,0c0.2,0,0.3,0.1,0.3,0.3v4c0,0.2-0.1,0.3-0.3,0.3l0,0 c-0.2,0-0.3-0.1-0.3-0.3V22z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "sailboat_x5F_fast",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "V2_00000116949656016418851850000001272925950374127007_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fast_Speed"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098192902501537738570000011869928475047132812_",
    gradientUnits: "userSpaceOnUse",
    x1: 45.55,
    y1: 20.3137,
    x2: 83.89,
    y2: 20.3137,
    gradientTransform: "matrix(1 0 0 -1 0 49.9)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.79
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.58
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.26
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.14
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.06
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.02
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000098192902501537738570000011869928475047132812_)"
    },
    d: "M83.9,29.8c-1.6-0.2-5.1,1.8-6.7,1.6 s-4.5-3-6.1-3.2s-5.1,1.8-6.7,1.6s-4.5-3-6.1-3.2s-5.1,1.8-6.7,1.6s-6.2-2.3-6.2-2.3s4.4,3.9,6,4.1s5.1-1.8,6.7-1.6 s4.5,3,6.1,3.2s5.1-1.8,6.7-1.6s4.5,3.5,6.1,3.2C78.9,32.9,83.9,29.9,83.9,29.8L83.9,29.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000069381438842440514880000015610149643404630975_",
    gradientUnits: "userSpaceOnUse",
    x1: 45.55,
    y1: 31.6096,
    x2: 83.89,
    y2: 31.6096,
    gradientTransform: "matrix(1 0 0 -1 0 49.9)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.79
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.58
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.26
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.14
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.06
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.02
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000069381438842440514880000015610149643404630975_)"
    },
    d: "M83.9,18c-1.6,0.2-5.1-1.8-6.7-1.6 s-4.5,3-6.1,3.2c-1.6,0.2-5.1-1.8-6.7-1.6s-4.5,3-6.1,3.2s-5.1-1.8-6.7-1.6S45.6,22,45.6,22s4.4-3.9,6-4.1s5.1,1.8,6.7,1.6 s4.5-3,6.1-3.2c1.6-0.2,5.1,1.8,6.7,1.6s4.5-3.5,6.1-3.2C78.9,14.9,83.9,18,83.9,18L83.9,18z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127762435759021174000000009900195766221272209_",
    gradientUnits: "userSpaceOnUse",
    x1: 32.49,
    y1: 15.3767,
    x2: 96.4,
    y2: 15.3767,
    gradientTransform: "matrix(1 0 0 -1 0 49.9)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.79
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.58
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.26
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.14
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.06
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.02
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000127762435759021174000000009900195766221272209_)"
    },
    d: "M89.7,38.9c-1.6-0.1-4.6-2.8-6.2-3 c-1.6-0.2-5,1.9-6.6,1.8c-1.6-0.1-4.6-2.8-6.2-3c-1.6-0.2-5,1.9-6.6,1.8c-1.6-0.1-4.6-2.8-6.2-3c-1.6-0.2-5,1.9-6.6,1.8 c-1.6-0.1-4.6-2.8-6.2-3c-1.6-0.2-5,1.9-6.6,1.8c-1.6-0.1-6.1-3.9-6.1-3.9s4.7,1.9,6.3,2s5-1.9,6.6-1.8s4.6,2.8,6.2,3 c1.6,0.2,5-1.9,6.6-1.8s4.6,2.8,6.2,3c1.6,0.2,5-1.9,6.6-1.8c1.6,0.1,4.6,2.8,6.2,3c1.6,0.2,5-1.9,6.6-1.8c1.6,0.1,4.6,2.8,6.2,3 c1.6,0.2,6.5-0.9,6.5-0.9S91.3,39,89.7,38.9L89.7,38.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000090265228137005539810000010155916780612496313_",
    gradientUnits: "userSpaceOnUse",
    x1: 32.49,
    y1: 36.5767,
    x2: 96.4,
    y2: 36.5767,
    gradientTransform: "matrix(1 0 0 -1 0 49.9)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.79
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.58
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.26
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.14
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.06
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.02
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000090265228137005539810000010155916780612496313_)"
    },
    d: "M89.7,9c-1.6,0.1-4.6,2.8-6.2,3 c-1.6,0.1-5-1.9-6.6-1.8c-1.6,0.1-4.6,2.8-6.2,3s-5-1.9-6.6-1.8s-4.6,2.8-6.2,3c-1.6,0.1-5-1.9-6.6-1.8c-1.6,0.2-4.6,2.8-6.2,3 c-1.6,0.2-5-1.9-6.6-1.8c-1.6,0.2-6.1,3.9-6.1,3.9s4.7-1.9,6.3-2c1.6-0.1,5,1.9,6.6,1.8c1.6-0.2,4.6-2.8,6.2-3s5,1.9,6.6,1.8 c1.6-0.2,4.6-2.8,6.2-3s5,1.9,6.6,1.8c1.6-0.1,4.6-2.8,6.2-3c1.6-0.1,5,1.9,6.6,1.8c1.6-0.2,4.6-2.8,6.2-3 c1.6-0.2,6.5,0.9,6.5,0.9S91.3,8.9,89.7,9L89.7,9z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Pleasure_Boat_00000078762794009816188430000007499316860817495473_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M44.8,19.9V28l-0.6,0.1c-5.3,1.1-12.9,1.7-20.7,1.7C8,29.8,1.9,24.7,1.7,24.5L1,23.9l0.7-0.6 C1.9,23.1,8,18,23.5,18c7.8,0,15.4,0.6,20.7,1.7L44.8,19.9L44.8,19.9L44.8,19.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M23.5,18.8c-15.4,0-21.3,5.1-21.3,5.1S8.1,29,23.5,29c8.1,0,15.4-0.6,20.5-1.6v-6.9 C38.9,19.5,31.6,18.8,23.5,18.8L23.5,18.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M35.7,20.1c-3.8-0.3-8-0.5-12.2-0.5c-11.8,0-17.9,3-20,4.4c2.1,1.3,8.2,4.4,20,4.4c4.3,0,8.5-0.2,12.2-0.5 c-0.4-1.1-0.6-2.4-0.6-3.8S35.4,21.2,35.7,20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M37.4,20.3c-0.5-0.1-1.1-0.1-1.7-0.2c-0.4,1.1-0.6,2.4-0.6,3.8s0.2,2.7,0.6,3.8c0.6,0,1.1-0.1,1.7-0.2 c-0.3-1.1-0.5-2.3-0.5-3.7S37.1,21.4,37.4,20.3L37.4,20.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M43.3,26.8v-5.7c-0.3-0.1-0.6-0.1-1-0.2c-1.5-0.2-3.1-0.5-4.9-0.7c-0.3,1.1-0.5,2.3-0.5,3.7s0.2,2.6,0.5,3.7 c1.8-0.2,3.4-0.4,4.9-0.7C42.6,26.9,43,26.8,43.3,26.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M42.5,21.7v4.4c-0.1,0-0.2,0-0.3,0.1c-1.3,0.2-2.7,0.4-4.2,0.6c-0.2-0.9-0.3-1.9-0.3-2.8c0-1,0.1-2,0.3-2.8 c1.5,0.2,2.9,0.4,4.2,0.6C42.3,21.7,42.4,21.7,42.5,21.7L42.5,21.7L42.5,21.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M35.3,23.9c0,0-3.2-3.7-7.2-3.7s-4.5,6.9-13.1,6.9c-5.8,0-11.6-3.2-11.6-3.2H35.3L35.3,23.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M23,22.9c0.6,0,1,0.4,1,1c0,0.6-0.5,1-1,1s-1-0.5-1-1C22,23.4,22.4,22.9,23,22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M38.7,23.6c0.2,0,0.3,0.1,0.3,0.3l0,0c0,0.2-0.1,0.3-0.3,0.3h-2.3c-0.2,0-0.3-0.1-0.3-0.3l0,0 c0-0.2,0.1-0.3,0.3-0.3H38.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M38.7,21.9c0-0.2,0.1-0.3,0.3-0.3l0,0c0.2,0,0.3,0.1,0.3,0.3v4c0,0.2-0.1,0.3-0.3,0.3l0,0 c-0.2,0-0.3-0.1-0.3-0.3C38.7,25.9,38.7,21.9,38.7,21.9z"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "cargo_x5F_ship_x5F_slow",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "V2_00000005249974370942880540000003868122789803736205_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cargo_Ship_00000106845310949198511630000003969325097895475626_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M55.1,14.6H21.5C6.7,14.6,1,23.7,1,23.7s5.7,9.5,20.5,9.5h33.6c0,0,14.3,0,25.2-3.2V17.4 C69.4,14.6,55.1,14.6,55.1,14.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M78.9,18.5v10.4c-10.5,2.8-23.7,2.9-24.1,2.9H21.3c-11.3,0-16.9-6-18.6-8.1c1.7-2,7.3-7.7,18.8-7.7h33.6 C55.2,16,68.4,16,78.9,18.5C78.9,18.5,78.9,18.5,78.9,18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M58.5,34.5h6.3l1.4-4.8c3.6-0.4,7.6-1,11.4-1.9v-8.2c-3.8-0.8-7.8-1.3-11.4-1.7l-1.4-5h-6.3L58.5,34.5 L58.5,34.5z M63.4,14.3l1.4,4.9c0.5,0,0.9,0.1,1.4,0.1c3.2,0.3,6.7,0.7,10,1.4v6c-3.3,0.8-6.8,1.3-10,1.6c-0.5,0-0.9,0.1-1.4,0.1 l-1.4,4.7h-2.8V14.3C60.6,14.3,63.4,14.3,63.4,14.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M60.6,33.1h2.8l1.4-4.7c0.4,0,0.9-0.1,1.4-0.1c3.2-0.3,6.7-0.8,10-1.6v-6c-3.3-0.7-6.8-1.1-10-1.4 c-0.5,0-0.9-0.1-1.4-0.1l-1.4-4.9h-2.8C60.6,14.3,60.6,33.1,60.6,33.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.6,
    y: 21.8,
    className: "st3",
    width: 7.6,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.4,
    y: 26.3,
    className: "st3",
    width: 7.8,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.4,
    y: 18.4,
    className: "st3",
    width: 7.8,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.2,
    y: 26.3,
    className: "st3",
    width: 7.8,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.2,
    y: 18.4,
    className: "st3",
    width: 7.8,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 26.3,
    className: "st3",
    width: 7.8,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 18.4,
    className: "st3",
    width: 7.8,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.8,
    y: 26.3,
    className: "st3",
    width: 7.8,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.4,
    y: 22.4,
    className: "st3",
    width: 7.8,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.2,
    y: 22.4,
    className: "st3",
    width: 7.8,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 22.4,
    className: "st3",
    width: 7.8,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.5,
    y: 26.3,
    className: "st3",
    width: 7.8,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.5,
    y: 18.4,
    className: "st3",
    width: 7.8,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.5,
    y: 22.4,
    className: "st3",
    width: 7.8,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.8,
    y: 22.4,
    className: "st3",
    width: 7.8,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.8,
    y: 18.4,
    className: "st3",
    width: 7.8,
    height: 3
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "cargo_x5F_ship_x5F_medium",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "V2_00000136383311254384627690000003244868978477908396_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mid_Speed_00000087378732045424184260000012755824561065916577_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018229833373181887130000001499860123702830516_",
    gradientUnits: "userSpaceOnUse",
    x1: 66.95,
    y1: 11.082,
    x2: 114.58,
    y2: 11.082,
    gradientTransform: "matrix(1 0 0 -1 0 49.9)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.74
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.51
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.33
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.19
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.08
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.02
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018229833373181887130000001499860123702830516_)"
    },
    d: "M114.6,39.1c-2-0.2-6.3,2.2-8.3,1.9 s-5.6-3.7-7.5-4s-6.3,2.2-8.3,1.9s-5.6-3.7-7.5-4s-6.3,2.2-8.3,1.9s-7.7-2.8-7.7-2.8s5.4,4.8,7.4,5.1s6.3-2.2,8.3-1.9 s5.6,3.7,7.5,4s6.3-2.2,8.3-1.9s5.6,4.3,7.5,4C108.4,43,114.6,39.1,114.6,39.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057140277397165503960000008130318163474491282_",
    gradientUnits: "userSpaceOnUse",
    x1: 66.01,
    y1: 41.2712,
    x2: 113.64,
    y2: 41.2712,
    gradientTransform: "matrix(1 0 0 -1 0 49.9)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.74
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.51
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.33
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.19
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.08
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.02
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057140277397165503960000008130318163474491282_)"
    },
    d: "M113.6,8.3c-2,0.2-6.3-2.2-8.3-1.9 c-2,0.3-5.6,3.7-7.5,4s-6.3-2.2-8.3-1.9c-2,0.3-5.6,3.7-7.5,4s-6.3-2.2-8.3-1.9c-2,0.3-7.7,2.8-7.7,2.8s5.4-4.9,7.4-5.1 s6.3,2.2,8.3,1.9s5.6-3.7,7.5-4s6.3,2.2,8.3,1.9s5.6-4.3,7.5-4C107.4,4.5,113.6,8.3,113.6,8.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181809041288930224210000015483578268529644984_",
    gradientUnits: "userSpaceOnUse",
    x1: 81.27,
    y1: 21.7226,
    x2: 104.49,
    y2: 21.7226,
    gradientTransform: "matrix(1 0 0 -1 0 49.9)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.74
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.51
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.33
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.19
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.08
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.02
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000181809041288930224210000015483578268529644984_)"
    },
    d: "M104.5,30.3c-1.4-0.2-5.6-1.2-7.5-1.5 s-6.3,2.2-8.3,1.9s-7.4-5.1-7.4-5.1s5.7,2.5,7.7,2.8s6.4-2.5,8.3-1.9S104.5,30.2,104.5,30.3L104.5,30.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000100369350510266383850000018016446568494798999_",
    gradientUnits: "userSpaceOnUse",
    x1: 81.27,
    y1: 31.0006,
    x2: 104.49,
    y2: 31.0006,
    gradientTransform: "matrix(1 0 0 -1 0 49.9)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.74
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.51
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.33
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.19
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.08
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.02
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000100369350510266383850000018016446568494798999_)"
    },
    d: "M104.5,16.8c-1.4,0.2-5.6,1.2-7.5,1.5 s-6.3-2.2-8.3-1.9s-7.4,5.1-7.4,5.1s5.7-2.5,7.7-2.8s6.4,2.5,8.3,1.9S104.5,16.8,104.5,16.8L104.5,16.8z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Cargo_Ship_00000083078124339476009250000009862460113218522540_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M55.1,14.5H21.5c-14.8,0-20.5,9-20.5,9S6.7,33,21.5,33h33.6c0,0,14.3,0,25.2-3.2V17.3 C69.4,14.5,55.1,14.5,55.1,14.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M78.9,18.3v10.4c-10.5,2.8-23.7,2.9-24.1,2.9H21.3c-11.3,0-16.9-5.9-18.6-8.1c1.7-2,7.3-7.7,18.8-7.7h33.6 C55.2,15.8,68.4,15.9,78.9,18.3C78.9,18.3,78.9,18.3,78.9,18.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M58.5,34.3h6.3l1.4-4.8c3.6-0.4,7.6-1,11.4-1.9v-8.2c-3.8-0.8-7.8-1.3-11.4-1.7l-1.4-5h-6.3 C58.5,12.7,58.5,34.3,58.5,34.3z M63.4,14.1l1.4,4.9c0.4,0,0.9,0.1,1.4,0.1c3.2,0.3,6.7,0.7,10,1.4v6c-3.3,0.8-6.8,1.3-10,1.6 c-0.5,0-0.9,0.1-1.4,0.1L63.4,33h-2.8V14.1L63.4,14.1L63.4,14.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M60.6,33h2.8l1.4-4.7c0.4,0,0.9-0.1,1.4-0.1c3.2-0.3,6.7-0.8,10-1.6v-6c-3.3-0.7-6.8-1.1-10-1.4 c-0.5,0-0.9-0.1-1.4-0.1l-1.4-4.9h-2.8C60.6,14.1,60.6,33,60.6,33z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.6,
    y: 21.6,
    className: "st3",
    width: 7.6,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.4,
    y: 26.2,
    className: "st3",
    width: 7.8,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.4,
    y: 18.2,
    className: "st3",
    width: 7.8,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.2,
    y: 26.2,
    className: "st3",
    width: 7.8,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.2,
    y: 18.2,
    className: "st3",
    width: 7.8,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 26.2,
    className: "st3",
    width: 7.8,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 18.2,
    className: "st3",
    width: 7.8,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.8,
    y: 26.2,
    className: "st3",
    width: 7.8,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.4,
    y: 22.2,
    className: "st3",
    width: 7.8,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.2,
    y: 22.2,
    className: "st3",
    width: 7.8,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 22.2,
    className: "st3",
    width: 7.8,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.5,
    y: 26.2,
    className: "st3",
    width: 7.8,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.5,
    y: 18.2,
    className: "st3",
    width: 7.8,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.5,
    y: 22.2,
    className: "st3",
    width: 7.8,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.8,
    y: 22.2,
    className: "st3",
    width: 7.8,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.8,
    y: 18.2,
    className: "st3",
    width: 7.8,
    height: 3
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "cargo_x5F_ship_x5F_fast"
  }, /*#__PURE__*/React.createElement("g", {
    id: "V2_00000158746472310255529510000001108450441416781729_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fast_Speed_00000086658196104614160590000011625422835379349381_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000058567458887198201550000004342270895638860201_",
    gradientUnits: "userSpaceOnUse",
    x1: 66.12,
    y1: 10.1733,
    x2: 145.57,
    y2: 10.1733,
    gradientTransform: "matrix(1 0 0 -1 0 49.9)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.79
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.58
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.26
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.14
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.06
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.02
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000058567458887198201550000004342270895638860201_)"
    },
    d: "M137.2,45.1c-2-0.2-5.7-3.5-7.7-3.7 s-6.2,2.4-8.2,2.2s-5.7-3.5-7.7-3.7s-6.2,2.4-8.2,2.2s-5.7-3.5-7.7-3.7s-6.2,2.4-8.2,2.2s-5.7-3.5-7.7-3.7s-6.2,2.4-8.2,2.2 s-7.6-4.8-7.6-4.8s5.8,2.3,7.8,2.5s6.2-2.4,8.2-2.2s5.7,3.5,7.7,3.7S96,36,98,36.1s5.7,3.5,7.7,3.7s6.2-2.4,8.2-2.2 s5.7,3.5,7.7,3.7s6.2-2.4,8.2-2.2c2,0.2,5.7,3.5,7.7,3.7s8.1-1.1,8.1-1.1S139.2,45.3,137.2,45.1L137.2,45.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158715198749558462600000017880176120620406702_",
    gradientUnits: "userSpaceOnUse",
    x1: 66.12,
    y1: 42.18,
    x2: 145.57,
    y2: 42.18,
    gradientTransform: "matrix(1 0 0 -1 0 49.9)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.79
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.58
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.26
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.14
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.06
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.02
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000158715198749558462600000017880176120620406702_)"
    },
    d: "M137.2,2.4c-2,0.2-5.7,3.5-7.7,3.7 c-2,0.2-6.2-2.4-8.2-2.2s-5.7,3.5-7.7,3.7s-6.2-2.4-8.2-2.2c-2,0.2-5.7,3.5-7.7,3.7s-6.2-2.4-8.2-2.2s-5.7,3.5-7.7,3.7 s-6.2-2.4-8.2-2.2c-2,0.2-7.6,4.8-7.6,4.8s5.8-2.3,7.8-2.5s6.2,2.4,8.2,2.2s5.7-3.5,7.7-3.7c2-0.2,6.2,2.4,8.2,2.2 s5.7-3.5,7.7-3.7s6.2,2.4,8.2,2.2s5.7-3.5,7.7-3.7c2-0.2,6.2,2.4,8.2,2.2c2-0.2,5.7-3.5,7.7-3.7c2-0.2,8.1,1.1,8.1,1.1 S139.2,2.2,137.2,2.4L137.2,2.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023991851929781397130000010207614926629529497_",
    gradientUnits: "userSpaceOnUse",
    x1: 83.58,
    y1: 20.382,
    x2: 131.21,
    y2: 20.382,
    gradientTransform: "matrix(1 0 0 -1 0 49.9)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.79
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.58
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.26
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.14
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.06
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.02
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000023991851929781397130000010207614926629529497_)"
    },
    d: "M131.2,29.8c-2-0.2-6.3,2.2-8.3,1.9 s-5.6-3.7-7.5-4s-6.3,2.2-8.3,1.9s-5.6-3.7-7.5-4s-6.3,2.2-8.3,1.9s-7.7-2.8-7.7-2.8S89,29.8,91,30s6.3-2.2,8.3-1.9 s5.6,3.7,7.5,4c2,0.2,6.3-2.2,8.3-1.9s5.6,4.3,7.5,4C125,33.7,131.2,29.8,131.2,29.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000028289252924678130790000007037197647883564217_",
    gradientUnits: "userSpaceOnUse",
    x1: 83.58,
    y1: 32.2512,
    x2: 131.21,
    y2: 32.2512,
    gradientTransform: "matrix(1 0 0 -1 0 49.9)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.79
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.58
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.26
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.14
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.06
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.02
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000028289252924678130790000007037197647883564217_)"
    },
    d: "M131.2,17.3c-2,0.2-6.3-2.2-8.3-1.9 s-5.6,3.7-7.5,3.9s-6.3-2.2-8.3-1.9s-5.6,3.7-7.5,4s-6.3-2.2-8.3-1.9s-7.7,2.8-7.7,2.8s5.4-4.9,7.4-5.1s6.3,2.2,8.3,1.9 s5.6-3.7,7.5-3.9s6.3,2.2,8.3,1.9s5.6-4.3,7.5-4C125,13.5,131.2,17.3,131.2,17.3z"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Cargo_Ship_00000153705665482548210680000006000495327355693730_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M55.1,14.5H21.5C6.7,14.5,1,23.6,1,23.6S6.7,33,21.5,33h33.6c0,0,14.3,0,25.2-3.2V17.3 C69.4,14.5,55.1,14.5,55.1,14.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M78.9,18.4v10.4c-10.5,2.8-23.7,2.9-24.1,2.9H21.3c-11.3,0-16.9-5.9-18.6-8.1c1.7-2,7.3-7.7,18.8-7.7h33.6 C55.2,15.9,68.4,15.9,78.9,18.4C78.9,18.4,78.9,18.4,78.9,18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M58.5,34.4h6.3l1.4-4.8c3.6-0.4,7.6-1,11.4-1.9v-8.2c-3.8-0.8-7.8-1.3-11.4-1.7l-1.4-5h-6.3 C58.5,12.8,58.5,34.4,58.5,34.4z M63.4,14.1l1.4,4.9c0.4,0,0.9,0.1,1.4,0.1c3.2,0.3,6.7,0.7,10,1.4v6c-3.3,0.8-6.8,1.3-10,1.6 c-0.5,0-0.9,0.1-1.4,0.1L63.4,33h-2.8V14.1C60.6,14.1,63.4,14.1,63.4,14.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M60.6,33h2.8l1.4-4.7c0.4,0,0.9-0.1,1.4-0.1c3.2-0.3,6.7-0.8,10-1.6v-6c-3.3-0.7-6.8-1.1-10-1.4 c-0.5,0-0.9-0.1-1.4-0.1l-1.4-4.9h-2.8C60.6,14.1,60.6,33,60.6,33z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.6,
    y: 21.6,
    className: "st3",
    width: 7.6,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.4,
    y: 26.2,
    className: "st3",
    width: 7.8,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.4,
    y: 18.2,
    className: "st3",
    width: 7.8,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.2,
    y: 26.2,
    className: "st3",
    width: 7.8,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.2,
    y: 18.2,
    className: "st3",
    width: 7.8,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 26.2,
    className: "st3",
    width: 7.8,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 18.2,
    className: "st3",
    width: 7.8,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.8,
    y: 26.2,
    className: "st3",
    width: 7.8,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.4,
    y: 22.2,
    className: "st3",
    width: 7.8,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.2,
    y: 22.2,
    className: "st3",
    width: 7.8,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 22.2,
    className: "st3",
    width: 7.8,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.5,
    y: 26.2,
    className: "st3",
    width: 7.8,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.5,
    y: 18.2,
    className: "st3",
    width: 7.8,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.5,
    y: 22.2,
    className: "st3",
    width: 7.8,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.8,
    y: 22.2,
    className: "st3",
    width: 7.8,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.8,
    y: 18.2,
    className: "st3",
    width: 7.8,
    height: 3
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCargoShipFast);
export default __webpack_public_path__ + "static/media/cargo_ship_fast.4beac54056759a9c63086bc9472fbd9f.svg";
export { ForwardRef as ReactComponent };